import React, {useContext, useEffect, useState} from 'react';

import en from '../i18n/locales/en';
import sp from '../i18n/locales/sp';
import Translation from '../i18n/models/translation';

interface LanguageContextType extends Translation {
  locale: string;
  setSelectedLanguage: (value: string) => void;
}

const LanguageContext = React.createContext<LanguageContextType>(
  {} as LanguageContextType,
);

export const languageObj = {
  en,
  sp,
};

export const LanguageContextProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>('sp');

  const init = () => {
    const value = localStorage.getItem('language');
    if (value && Object.keys(languageObj).includes(value)) {
      setSelectedLanguage(value);
    } else {
      setSelectedLanguage('sp'); //Conseguir la manera de obtener el lenguaje del dispositivo
    }
  };

  useEffect(() => {
    init();
  });

  const value = {
    ...languageObj[selectedLanguage as 'en' | 'sp'],
    locale: selectedLanguage as 'en' | 'sp',
    setSelectedLanguage: (value: string) => {
      setSelectedLanguage(value);
      localStorage.setItem('language', value);
    },
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTranslation = () => useContext(LanguageContext);
